<template>
    <div class="col-md-6">
        <div class="panel panel-default">
            <div class="panel-heading">
                {{trans_heading}} ({{trans_total}}: {{sum}})
                <select name="workTimeMonthDay" id="workTimeMonthDay" class="pull-right" v-model="selectedMonth">
                    <option :value="index" v-for="(month, index) in months">{{month}}</option>
                </select>
            </div>
            <div class="panel-body">
                <plot :id="plotId" :ref="plotId" :options="options" :type="type"></plot>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import Plot from './Plot';

  export default {
    components: {'Plot': Plot},
    data() {
      return {
        trans_heading: Worklog.workTimeMonthDay.trans_heading,
        trans_total  : Worklog.workTimeMonthDay.trans_total,
        months       : Worklog.workTimeMonthDay.months,
        selectedMonth: Worklog.workTimeMonthDay.month,
        url          : Worklog.workTimeMonthDay.url,
        sum          : '',
        plotId       : 'workTimeMonthDayChart',
        type         : 'bar',
        options      : {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          },
          legend: {
            display: false
          }
        },
      }
    },
    watch     : {
      selectedMonth: function (val) {
        this.fetchData();
      },
    },
    mounted() {
      this.sum = Worklog.workTimeMonthDay.data.sum;
      this.$refs[ this.plotId ].updateChart(Worklog.workTimeMonthDay.data.data);
    },
    methods   : {
      fetchData() {
        axios.get(this.url.replace(':month', this.selectedMonth))
          .then(response => {
            response.data && response.data.data && this.$refs[ this.plotId ].updateChart(response.data.data);
            response.data && (this.sum = response.data.sum);
          })
          .catch(e => {
            this.$refs[ this.plotId ].updateChart({
              dataSets: [],
              labels  : []
            });
          })
      }
    }
  }
</script>
